import {Col, Row, Form, Button} from "react-bootstrap";
import React, {useState} from "react";
import PasswordForm from "../form/passwordForm";
import ApiService from "../../services/ApiService";
import {useLocation, useNavigate} from "react-router-dom";
import AppRoute from "../../utils/AppRoute";
import GenericErrorModal from "../modal/genericErrorModal";

const Password = () => {

    const navigate = useNavigate();
    const [password, setPassword] = useState();
    const [checkPassowrd, setCheckPassword] = useState();
    const location = useLocation()
    const queryParameters = new URLSearchParams(location.search)

    const [errorModal, setErrorModal] = useState({
        state: false,
        title: "",
        body: ""
    });

    const handleReimpostaPassword = (e) => {
        e.preventDefault();

        let passwordObj = {
            password: password
        }
        ApiService.setNewPassword(passwordObj, queryParameters.get("token"))
            .then(response => {
                navigate(AppRoute.LOGIN);
            })
            .catch(() => setErrorModal({
                state: true,
                title: "Errore nel reset della password",
                body: "Ok"
            }))
    }

    const handleCloseErrorModal = () => setErrorModal({
        state: false,
        title: "",
        body: ""
    })

    return (
        <>
            <Row>
                <Col lg={6}>

                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>Rimposta password</h2>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Form>
                                <div className={'mb-3'}>
                                    <PasswordForm event={setPassword} label={'Nuova password'}/>
                                </div>

                                <div className={'mb-2'}>
                                    <PasswordForm event={setCheckPassword} label={'Conferma nuova password'}/>
                                    <p className={'mt-1'}>*campi obbligatori</p>
                                </div>

                                <div className={'w-100 d-flex justify-content-end mt-2'}>
                                    <Button variant={'primary'}
                                            disabled={(password === undefined || checkPassowrd === undefined)}
                                            type={'submit'} className={'px-5 fw-bold'}
                                            onClick={(e) => handleReimpostaPassword(e)}>Salva e torna al login</Button>
                                </div>
                            </Form>
                        </Col>
                    </Row>

                </Col>
            </Row>

            <GenericErrorModal handleClose={handleCloseErrorModal} contentText={errorModal} showModal={errorModal.state}/>

        </>

    );
}

export default Password;